/**
 * There will be one saga file per component
 */
import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_AUTH_TOKEN_SUCCESS,
    GET_AUTH_TOKEN_FAILURE,
} from './../actions/constants';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getAuthToken(action) {
    let url = '';
    // eslint-disable-next-line no-undef
    if (process.env.ENABLE_SSO) {
        url = `mycaseauthserver/oauth/token?client_id=test123&client_secret=test&grant_type=custom&scope=extended&idptoken=${localStorage.getItem(
            'authToken'
        )}`;
    } else {
        url =
            'mycaseauthserver/oauth/token?client_id=test123&client_secret=test&grant_type=custom&scope=extended&idptoken=mycasetoken&username=vecchm1';
    }
    try {
        const result = yield axios.post(url).then((response) => { 
            return response.data;
        });
        if (action.payload.enableIDPAuth) {
            localStorage.setItem('authToken', result.value);
        } else {
            localStorage.setItem('authToken', result.value);
        }
        yield put({ type: GET_AUTH_TOKEN_SUCCESS, token: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
        });
        yield put({
            type: GET_AUTH_TOKEN_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
